var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ax-results-panel" },
    [
      _c("div", { staticClass: "result-panel-toggle-button" }, [
        _c(
          "div",
          { staticClass: "ax-toggle-buttons--washed-denim-based horizontal " },
          [
            _c(
              "button",
              {
                staticClass: "ax-button",
                class: { active: _vm.$data.activeButtonId === "btnEntity" },
                attrs: { type: "button", id: "btnEntity" },
                on: {
                  click: function($event) {
                    return _vm.onClick($event)
                  },
                  keydown: function($event) {
                    return _vm.onKeyDown($event)
                  }
                },
                model: {
                  value: _vm.entitySelected,
                  callback: function($$v) {
                    _vm.entitySelected = $$v
                  },
                  expression: "entitySelected"
                }
              },
              [_vm._v("\n        Entities\n      ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "ax-button",
                class: { active: _vm.$data.activeButtonId === "btnMenu" },
                attrs: { type: "button", id: "btnMenu" },
                on: {
                  click: function($event) {
                    return _vm.onClick($event)
                  },
                  keydown: function($event) {
                    return _vm.onKeyDown($event)
                  }
                },
                model: {
                  value: _vm.menuSelected,
                  callback: function($$v) {
                    _vm.menuSelected = $$v
                  },
                  expression: "menuSelected"
                }
              },
              [_vm._v("\n        Menu\n      ")]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("EntityResultsPanel", {
        attrs: {
          show: _vm.panelToDisplay === "searching-entities",
          caption: "Search Result",
          mode: "search"
        },
        on: { navigate: _vm.navigate }
      }),
      _vm._v(" "),
      _c("EntityResultsPanel", {
        attrs: {
          show: _vm.panelToDisplay === "recent-entities",
          caption: "Recently accessed",
          mode: "history"
        },
        on: { navigate: _vm.navigate }
      }),
      _vm._v(" "),
      _c("MenuResultsPanel", {
        attrs: {
          show: _vm.panelToDisplay === "searching-menu",
          caption: "Search Result",
          mode: "search"
        },
        on: { navigate: _vm.navigate }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }